import * as React from 'react';
import PropTypes from "prop-types";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import AppForm from "./AppForm";
import Button from "../components/Button";
import useAfterUpdateEffect from "../utils/useAfterUpdateEffect";
import {useTranslation} from "react-i18next";

function AppModalForm(props) {
  const { t } = useTranslation();
  const [saving, setSaving] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(props.modalOpen);
  const toggleModalOpen = () => setModalOpen(!modalOpen);
  const formRef = React.createRef();

  useAfterUpdateEffect(() => {
    if(props.handlerOnModalOpen){
      props.handlerOnModalOpen(modalOpen)
    }
  }, [modalOpen])

  return (
    <React.Fragment>
      {props.children && React.cloneElement(props.children, {
        onClick: toggleModalOpen,
      })}
      {modalOpen && <Modal isOpen scrollable size={props.size}>
        <ModalHeader toggle={toggleModalOpen}>{props.modalTitle}</ModalHeader>
        <ModalBody>
          <AppForm
            ref={formRef}
            saveButton={false}
            onSavingChange={saving => setSaving(saving)}
            form={props.form}
            {...props.formProps}
            onCreated={createdDocument => {
              if(props.formProps.onCreated){
                props.formProps.onCreated(createdDocument);
              }

              setModalOpen(false);
            }}
            onUpdated={data => {
              if(props.formProps.onUpdated){
                props.formProps.onUpdated(data)
              }

              setModalOpen(false);
            }}
          />
        </ModalBody>
        <ModalFooter>
          {props.footerButtons ? (
            props.footerButtons(toggleModalOpen)
          ) : (
            <>
              <Button color="secondary" className="mb-0" onClick={toggleModalOpen}>{t('common:btn.cancel')}</Button>
              <Button loading={saving} color="primary" className="mb-0" onClick={() => {
                formRef.current.submit()
              }}>{props.modalButtonAccept ?? <React.Fragment>
                <i className="fas fa-save" />
                <span>{t('common:btn.save')}</span>
              </React.Fragment>}</Button>
            </>)}
        </ModalFooter>
      </Modal>}
    </React.Fragment>
  );
}

AppModalForm.defaultProps = {
  modalOpen: false,
  size: 'lg',
};

AppModalForm.propTypes = {
  handlerOnModalOpen: PropTypes.func,
  modalOpen: PropTypes.bool,
  modalButtonAccept: PropTypes.node,
  size: PropTypes.string,
  modalTitle: PropTypes.string.isRequired,
  form: PropTypes.func.isRequired,
  formProps: PropTypes.shape({
    apiFn: PropTypes.shape({
      create: PropTypes.func,
      update: PropTypes.func,
      custom: PropTypes.func,
    }).isRequired,
    onCreated: PropTypes.func,
    onUpdated: PropTypes.func,
    onCustomAction: PropTypes.func
  }),
  footerButtons: PropTypes.func,
};

export default AppModalForm;
